import PropTypes from 'prop-types';
import { css } from '@emotion/react';

import { TRACK_EVENT_NAMES } from 'lib/tracking';

import { colors } from 'styles/theme';
import { tabletUp } from 'styles/utils';

import Text from 'components/shared/Text/Text';
import Link from 'components/shared/Link/Link';
import Flexbox from 'components/shared/Flexbox/Flexbox';
import Container from 'components/shared/Container/Container';
import VerticalRhythm from 'components/shared/VerticalRhythm/VerticalRhythm';

import { menuItemShape } from './InfoCenter.config';

const textCss = css`
  &.MuiTypography-root {
    letter-spacing: 1.5px;

    ${tabletUp} {
      &:hover {
        color: ${colors.darkPurple};
      }
    }
  }
`;

const rootCss = css`
  ${tabletUp} {
    margin-top: 15px;
  }
`;

function InfoCenterNavbar({ currentSlug, menuItems }) {
  return (
    <VerticalRhythm tabletUp={42} css={rootCss}>
      <Container>
        <Flexbox justifyContent="space-between" alignItems="baseline">
          {menuItems.map(menuItem => {
            const isSelected = menuItem.slug === currentSlug;
            const trackEvent = {
              event: TRACK_EVENT_NAMES.INFO_CENTER_NAVBAR_CLICK,
              category: menuItem.label,
              label: menuItem.label,
            };

            return (
              <Link key={menuItem.slug} href={menuItem.href} track={trackEvent}>
                <Text
                  css={textCss}
                  variant="caption"
                  fontWeight={isSelected ? 500 : 300}
                  color={colors.textColor}
                  uppercase
                >
                  {menuItem.label}
                </Text>
              </Link>
            );
          })}
        </Flexbox>
      </Container>
    </VerticalRhythm>
  );
}

InfoCenterNavbar.propTypes = {
  currentSlug: PropTypes.string,
  menuItems: PropTypes.arrayOf(PropTypes.shape(menuItemShape)),
};

export default InfoCenterNavbar;
